import {
  Box,
  Button,
  ButtonBase,
  Divider,
  FormHelperText,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Container, height } from "@mui/system";
import axiosInstance from "../../axiosInterceptor";
import axiosInterceptor from "../../axiosInterceptor";

import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Paper from "@mui/material/Paper";
import UploadImage from "../BugReport/UploadImage";
import { confirmAlert } from "react-confirm-alert"; // Import
import { Row, Col, Form, Card } from "react-bootstrap";
import Select from "react-select";
import DownloadCard from "../Admin/DownloadData/DownloadCard";

import { useHistory } from "react-router-dom";
import CustomConfirm from "../../components/ConfirmAlert/CustomConfirm";

export const DataRequestPage = () => {
  const CustomBox = styled(Box)({
    "&.MuiBox-root": {
      backgroundColor: "#fff",
      borderRadius: "2rem",
      boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
      padding: "1rem",
      margin: "1rem",
      height: "40%",
    },
    "&.MuiBox-root:hover, &.MuiBox-root.dragover": {
      opacity: 0.6,
    },
  });

  const [loading, setLoading] = useState(false);
  const [allSurveyIds, setAllSurveyIds] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null); //{"value":"cognition","label":"Need for Cognition Scale"}
  const [file, setFile] = useState([]);
  const [email, setEmail] = useState("test@gmail.com");
  const [url, setUrl] = useState("testurl") 


  const [downloads, setDownloads] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const [allRequests,setAllRequests] =  useState(null);//my all requests

  let history = useHistory();
  let user;
  useEffect(() => {
    user = JSON.parse(localStorage.getItem("user"));
    setEmail(user.email);
    // console.log("user:" + user.email);
  }, []);

  // const fetchMyRequests = async () => {
  //   try {
  //     if(userResult.data.user.requestAllow){
  //       const pendingRequests= await axiosInstance().get(
  //         "admin/getAllRequests/" + encodeURIComponent(email)
  //       );
  //       // console.log("getAllRequests:"+ JSON.stringify(pendingRequests.data.data))
  //       setAllRequests(pendingRequests.data.data)
  //     }
  //   }
  //   catch(e){
  //     console.log("updateUser() error:"+e)
  //   }
  // }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const resp = await axiosInstance().get("user/all-download-id");
        if (resp.data.survey) {
          let allIDs = resp.data.survey;
          allIDs = allIDs.map((item) => {
            return { value: item.id, label: item.name, type: item.type };
          });
          // console.log("allIDs:"+ JSON.stringify(allIDs))
          setAllSurveyIds(allIDs);
        }
      } catch (err) {
        console.log(err);
      }
      setLoading(false);
    };
    fetchData();
    getDownload();
  }, []);

  // useEffect(() => {
  //   console.log("selectedOption:" + selectedOption); //{"value":"cognition","label":"Need for Cognition Scale"}
  // }, [selectedOption]);


  const handleLabel = (option) => {
    // console.log(JSON.stringify(option)); //{"value":"cognition","label":"Need for Cognition Scale"}
    setSelectedOption(option);
    // console.log("label:"+JSON.stringify(option))
  };

  const onSubmit = async () => {
    const urls = [];
    try {
      for (let f of file) {
        const uploadConfig = await axiosInstance().post("report/upload", {
          name: f.name,
          type: f.type,
          source: "datarequest",
        });
        // console.log("uploadConfig:"+JSON.stringify(uploadConfig));
        // console.log(keyValue(f));
        urls.push(uploadConfig.data.key);
        console.log("type:" + f.type);

        await axios.put(uploadConfig.data.url, f, {
          headers: {
            "Content-Type": f.type,
          },
        });
        setUrl(urls[0]);

        await axiosInstance().post("report/add-request", {
          email: email,
          status: "pending",
          survey: selectedOption, //{"value":"cognition","label":"Need for Cognition Scale",type:"new/old"}
          urls: urls,
        });
      }

      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Card style={{ width: "25rem" }} className="confirmCard">
              <Card.Body>
                <Card.Title>Thank you</Card.Title>
                <Card.Text>
                  We have received your request, thank you!
                </Card.Text>
                <Container fluid>
                  <Row>
                    <Col xs={6} className="text-left">
                      <Button
                        variant="outline-success"
                        className="w-100"
                        onClick={() => {
                          if (history) {
                            history.push("/");
                          } else {
                            window.location = "/";
                          }
                          onClose();
                        }}
                      >
                        OK
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Card.Body>
            </Card>
          );
        },
      });
    } catch (e) {
      console.log(e);
    } finally {
      setFile([]);
    }
  };

  const getDownload = useCallback(async () => {
    setLoading(true);
    try {
      // const api = `admin/list/${type}`;

      const api = `user/download-list`;
      const response = await axiosInterceptor().get(api);
      // console.log("getDownload datareq :"+","+JSON.stringify(response.data))
      // response.data.downloads.map((x) => {
      //   console.log("xxx: " + x._id);
      // });
      setDownloads(response.data.downloads);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  }, []);

  const downloadAlert = useCallback((url) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <CustomConfirm
            title="Download Link"
            onClose={onClose}
            text="Please click to start downloading."
          >
            <Container fluid className="p-0">
              <Row>
                <Col xs={12}>
                  <a
                    href={url}
                    // className="download-button text-dark"
                    style={{ textDecoration: "none" }}
                    target="_blank"
                  >
                    <Button
                      variant="outline-success"
                      className="w-100"
                      block
                      onClick={() => {
                        onClose();
                        // console.log(url);
                      }}
                    >
                      Click Here to Download
                    </Button>
                  </a>
                </Col>
              </Row>
            </Container>
          </CustomConfirm>
        );
      },
    });
  }, []);

  const getDownloadLink = useCallback(async (_id) => {
    try {
      // console.log("getDownloadLink test _id:" + _id);
      const response = await axiosInterceptor().get(
        "user/download-link/" + _id
      );
      // console.log("getDownloadLink test:" + JSON.stringify(response.data));
      downloadAlert(response.data.url);
    } catch (err) {
      console.log(err);
    }
  }, []);

  return (
    <Container fluid="true" className="text-center">
      {/* <Container
          // sx={{ bgcolor: '#cfe8fc'}}
          // alignItems="center"
          // justifyContent='center'
          > */}
      {downloads.map((d) => (
        <DownloadCard
          name={d.name + ", " + d.type}
          description={d.description}
          createdAt={d.createdAt}
          surveyId={d.surveyId}
          type={d.type}
          _id={d._id}
          getLink={getDownloadLink}
          kind={"new"}
          // getNew={getNewDownloadLink}
          downloading={downloading}
          compileLimit={true}
        />
      ))}
      <Stack
      // direction={{ xs: 'column', md: 'row' }}
      // spacing={{ xs: 1, sm: 2, md: 4 }}
      // alignItems="center"
      // justifyContent='center'
      // width='50%'
      >
        <hr />
        <CustomBox>
          <Box
            // backgroundColor = 'red'
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              position: "relative",
              width: "100%",
              height: "13rem",
              border: "2px dashed #4267b2",
              borderRadius: "20px",
            }}
          >
            <a
              href="https://yourmorals-public-data.s3.us-west-2.amazonaws.com/Final+YourMorals+Agreement.pdf"
              target="_blank"
              download
            >
              Download Aggrement
            </a>

            {/* <Button onClick={onDownload}>Download Agreenment</Button> */}
            {/* <a href="https://drive.google.com/file/d/1tSxK91n9HU0AWLSYHXISjotb12KTAepG/view?usp=sharing" target="_blank" download="myFile">Download file</a> */}
          </Box>
        </CustomBox>

        <CustomBox>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              position: "relative",
              width: "100%",
              height: "13rem",
              border: "2px dashed #4267b2",
              borderRadius: "20px",
            }}
            //   ref={wrapperRef}
            //   onDragEnter={onDragEnter}
            //   onDragLeave={onDragLeave}
            //   onDrop={onDragLeave}
          >
            <Stack justifyContent="center" sx={{ p: 1, textAlign: "center" }}>
              <Typography variant="body1" component="span">
                <strong>Sign and Upload Agreement</strong>
                <UploadImage
                  file={file}
                  setFile={setFile}
                  description={"Upload at most one png"}
                  maxImg={1}
                />
              </Typography>
              <Typography variant="body2" component="span">
                {/* JPG, JPEG, PNG */}
              </Typography>
            </Stack>
          </Box>
        </CustomBox>
      </Stack>

      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={6}
      >
        <Select
          // closeMenuOnSelect={false}
          // components={animatedComponents}
          // defaultValue={[labelOptions[0]]}
          // isMulti
          // value = {selectedOption||labelOptions[0]}
          width="200px"
          placeholder={"Suvey Data to Request"}
          options={allSurveyIds}
          onChange={handleLabel}
        />
        <Button
          variant="outlined"
          disabled={file.length !== 1 || !selectedOption}
          onClick={onSubmit}
        >
          Submit Request
        </Button>
      </Stack>

      <Stack
        // direction="row"
        // justifyContent="center"
        // alignItems="center"
        // spacing={6}
      >
        {/* <hr/>
        <h3> Your requests </h3> */}

        
      </Stack>
      
    </Container>
  );
};
